import React, { useState } from 'react';
import { Search } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const SEARCH_MODES = [
  { value: 'name', label: 'Name' },
  { value: 'content', label: 'Content' },
  { value: 'subject', label: 'Subject' },
];

export default function BookSubjectSearch({ initialValue = '', initialMode = 'name', compact = false }) {
  const [query, setQuery] = useState(initialValue);
  const [mode, setMode] = useState(initialMode);
  const navigate = useNavigate();
  const isSimple = !compact;

  const submit = (event) => {
    event.preventDefault();
    const value = query.trim();
    if (value) navigate(`/search?mode=${mode}&q=${encodeURIComponent(value)}`);
  };

  return (
    <form className={`book-search-form ${compact ? 'book-search-form--compact' : ''} ${isSimple ? 'book-search-form--simple' : ''}`} onSubmit={submit}>
      <div className="book-search-modes" role="radiogroup" aria-label="Book search type">
        {SEARCH_MODES.map((item) => <button type="button" role="radio" aria-checked={mode === item.value} className={mode === item.value ? 'active' : ''} key={item.value} onClick={() => setMode(item.value)}>{item.label}</button>)}
      </div>
      <div className="subject-search">
        <Search size={compact ? 19 : 20} aria-hidden="true" />
        <input
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          placeholder={mode === 'name' ? 'Search by book name' : mode === 'content' ? 'Search inside books' : 'Search by subject, e.g. tennis rules'}
          aria-label={`Search books by ${mode}`}
        />
        <button type="submit" disabled={!query.trim()}>Search</button>
      </div>
    </form>
  );
}
